import React from 'react';
import { injuryReportPanelClassName } from './injuryReportStyles';

const POSITION_OPTIONS = [
	{ value: '', label: 'All positions' },
	{ value: 'quarterback', label: 'QB' },
	{ value: 'running back', label: 'RB' },
	{ value: 'wide receiver', label: 'WR' },
	{ value: 'tight end', label: 'TE' }
];

const STATUS_BUCKET_OPTIONS = [
	{ value: '', label: 'All statuses' },
	{ value: 'out', label: 'Out' },
	{ value: 'doubtful', label: 'Doubtful' },
	{ value: 'questionable', label: 'Questionable' },
	{ value: 'probable', label: 'Probable' },
	{ value: 'ir', label: 'IR' },
	{ value: 'pup', label: 'PUP' },
	{ value: 'inactive', label: 'Inactive' },
	{ value: 'suspended', label: 'Suspended' },
	{ value: 'nfi', label: 'NFI' },
	{ value: 'other', label: 'Other' }
];

const SORT_OPTIONS = [
	{ value: 'impact', label: 'Impact' },
	{ value: 'severity', label: 'Severity' },
	{ value: 'rank', label: 'FF rank' },
	{ value: 'name', label: 'Name' }
];

const selectClassName =
	'w-full rounded-xl border border-gray-200 dark:border-dark-border bg-gray-50 bg-opacity-50 dark:bg-dark-bg px-3 py-2 text-sm text-gray-800 dark:text-dark-text focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition';

const filterFieldClassName = 'flex flex-col flex-1 min-w-0 sm:min-w-32';

const filterLabelClassName =
	'mb-1.5 text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400';

export default function InjuryReportFilters({ filters, onFilterChange, teams = [] }) {
	return (
		<div className={`${injuryReportPanelClassName} p-4 md:p-5`}>
			<div className="flex flex-col gap-4 lg:flex-row lg:flex-wrap lg:items-end">
				<div className={filterFieldClassName} style={{ minWidth: '12.5rem' }}>
					<label className={filterLabelClassName} htmlFor="injury-report-search">
						Search
					</label>
					<input
						id="injury-report-search"
						type="text"
						className={selectClassName}
						placeholder="Name, injury, status…"
						value={filters.search}
						onChange={(e) => onFilterChange('search', e.target.value)}
					/>
				</div>

				<div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:flex lg:flex-1 lg:gap-3">
					<div className={filterFieldClassName}>
						<label className={filterLabelClassName}>Position</label>
						<select
							className={selectClassName}
							value={filters.position}
							onChange={(e) => onFilterChange('position', e.target.value)}
						>
							{POSITION_OPTIONS.map((opt) => (
								<option key={opt.value || 'all'} value={opt.value}>
									{opt.label}
								</option>
							))}
						</select>
					</div>

					<div className={filterFieldClassName}>
						<label className={filterLabelClassName}>Team</label>
						<select
							className={selectClassName}
							value={filters.team}
							onChange={(e) => onFilterChange('team', e.target.value)}
						>
							<option value="">All teams</option>
							{teams.map((name) => (
								<option key={name} value={name}>
									{name}
								</option>
							))}
						</select>
					</div>

					<div className={filterFieldClassName}>
						<label className={filterLabelClassName}>Status</label>
						<select
							className={selectClassName}
							value={filters.status_bucket}
							onChange={(e) => onFilterChange('status_bucket', e.target.value)}
						>
							{STATUS_BUCKET_OPTIONS.map((opt) => (
								<option key={opt.value || 'all'} value={opt.value}>
									{opt.label}
								</option>
							))}
						</select>
					</div>

					<div className={filterFieldClassName}>
						<label className={filterLabelClassName}>Sort</label>
						<select
							className={selectClassName}
							value={filters.sort}
							onChange={(e) => onFilterChange('sort', e.target.value)}
						>
							{SORT_OPTIONS.map((opt) => (
								<option key={opt.value} value={opt.value}>
									{opt.label}
								</option>
							))}
						</select>
					</div>
				</div>
			</div>
		</div>
	);
}
